import { isRedirect } from '@tanstack/react-router';
import { UnauthorizedError } from 'cpool-utils';

const MAX_RETRIES = 3;
const CLIENT_ERROR_MIN = 400;
const CLIENT_ERROR_MAX = 499;

const getStatus = (error: unknown) =>
    typeof error === 'object' && error !== null && 'status' in error && typeof error.status === 'number'
        ? error.status
        : undefined;

// 4xx are final answers; retrying only repeats the request (and non-idempotent commands)
export const shouldRetryRequest = (failureCount: number, error: unknown): boolean => {
    if (isRedirect(error) || error instanceof UnauthorizedError) return false;
    const status = getStatus(error);
    if (status !== undefined && status >= CLIENT_ERROR_MIN && status <= CLIENT_ERROR_MAX) return false;
    return failureCount < MAX_RETRIES;
};
